import { notification } from 'antd';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { BackButton } from 'src/components/BackButton/BackButton';
import { CreateFormPage } from 'src/components/FormPages/CreateFormPage';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { CreatePartnerRequest } from 'src/generated-api-client';
import { useLoadResources } from 'src/hooks/useLoadResources';
import { PartnerCreateForm } from 'src/pages/PartnersCreate/components/PartnerCreateForm';
import { PartnersStore } from 'src/stores/PartnersStore/PartnersStore';
import { CountryResourceStore } from 'src/stores/Resources/CountryResourceStore';
import { JahezComissionTypeResourceStore } from 'src/stores/Resources/JahezComissionTypeResourceStore';
import { PartnerTypeResourceStore } from 'src/stores/Resources/PartnerTypeResourceStore';
import { ProductOfferingTypeResourceStore } from 'src/stores/Resources/ProductOfferingTypeResourceStore';
import { SpecializationResourceStore } from 'src/stores/Resources/SpecializationResourceStore';

export const PartnerCreatePage = observer(() => {
    const { t } = useTranslation();
    const { isLoadingResources } = useLoadResources([
        CountryResourceStore,
        SpecializationResourceStore,
        ProductOfferingTypeResourceStore,
        PartnerTypeResourceStore,
        JahezComissionTypeResourceStore,
    ]);

    const listUrl = EntityLinks.partners.list?.();

    const handleFinish = async (values: CreatePartnerRequest) => {
        const newItem = await store.create(values);

        if (!store.createItemLoader.hasError && newItem) {
            notification.success({
                message: t('App.Msgs.CreateSuccess', {
                    name: newItem.arabicName,
                }),
            });

            const saveUrl = EntityLinks.partners.itemDetails!(newItem.id!);

            saveUrl && Router.navigate(saveUrl);
        }
    };

    return (
        <CreateFormPage
            store={store}
            pageName="partner-create"
            title={t('App.Pages.PartnersCreate.Title')}
            saveText={<Trans i18nKey="App.Pages.PartnerEdit.CreatePartner" />}
            handleFinish={handleFinish}
            initialValues={{
                country: 'SAU',
            }}
            isLoading={isLoadingResources}
            showOnlyLoading={isLoadingResources}
            onCancel={() => {
                listUrl && Router.navigate(listUrl);
            }}
            headerTopPanel={<BackButton to={listUrl} />}
        >
            <PartnerCreateForm />
        </CreateFormPage>
    );
});

const store = PartnersStore;
